import React from 'react';
import { Button } from '../components/ui/Button';
interface HomePageProps {
  onRefer: () => void;
}
export function HomePage({
  onRefer
}: HomePageProps) {
  return <div className="min-h-screen flex flex-col items-center justify-center px-4 font-sans" data-id="element-66">
      <div className="text-center" data-id="element-67">
        <img src="https://cdn.magicpatterns.com/uploads/4phTewesRknpwwZMqHaus9/LL_logo.png" alt="Lend-A-Loan" className="h-20 object-contain mx-auto mb-10" data-id="element-68" />
        <h1 className="text-2xl font-bold text-gray-900 tracking-tight mb-2" data-id="element-69">
          Employee Referral Portal
        </h1>
        <p className="text-gray-500 text-sm mb-3 max-w-xs mx-auto" data-id="element-70">
          Help us grow the team — refer someone you'd love to work with.
        </p>
        <p className="text-green-700 text-sm font-semibold mb-10 max-w-xs mx-auto bg-green-50 border border-green-200 rounded-lg px-4 py-2.5" data-id="element-71">
          Refer a friend and receive a $100 gift card
        </p>
        <Button onClick={onRefer} className="px-8 py-3 text-base" data-id="element-72">
          Refer a Friend
        </Button>
      </div>
    </div>;
}